// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Activation_radio__SMS59 {
  display: flex;
  gap: 8px;
  margin: 20px 0;
}
.Activation_radio__SMS59 label {
  width: 50%;
  height: 40px;
  padding: 0 8px;
  background-color: #FFFFFF;
  border: 1px solid #00007a;
  border-radius: 8px;
  display: flex;
  align-items: center;
}
.Activation_radio__SMS59 label:after {
  top: 13.5px !important;
  left: 12px !important;
}
.Activation_radio__SMS59 label:not(:last-of-type) {
  margin-right: 0;
}

@media screen and (max-width: 600px) {
  .Activation_radio__SMS59 {
    flex-direction: column;
  }
  .Activation_radio__SMS59 label {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/pages/Activation/Activation.module.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,QAAA;EACA,cAAA;AAIJ;AAFI;EACI,UAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAIR;AAFQ;EACI,sBAAA;EACA,qBAAA;AAIZ;AADQ;EACI,eAAA;AAGZ;;AAGA;EACI;IACI,sBAAA;EAAN;EACM;IACI,WAAA;EACV;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.radio{\n    display: flex;\n    gap: 8px;\n    margin: 20px 0;\n\n    label{\n        width: 50%;\n        height: 40px;\n        padding: 0 8px;\n        background-color: #FFFFFF;\n        border: 1px solid colors.$primary8;\n        border-radius: 8px;\n        display: flex;\n        align-items: center;\n\n        &:after{\n            top: 13.5px!important;\n            left: 12px!important;\n        }\n\n        &:not(:last-of-type){\n            margin-right: 0;\n        }\n    }\n}\n\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n    .radio {\n        flex-direction: column;\n        label{\n            width: 100%;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"radio": `Activation_radio__SMS59`
};
export default ___CSS_LOADER_EXPORT___;
